@import '../../assets/styles/components.css';

@layer components {
  :host {
    @apply cursor-pointer outline-none text-neutral-dark;
    @apply flex-col inline-flex;

    abds-icon {
      @apply absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2;
      @apply text-brand;
    }

    abds-label {
      @apply mt-0.5;
    }

    abds-supporting-text {
      @apply ml-8 mt-0.5;
    }

    .checkbox-label-container {
      @apply flex gap-x-2 items-start;
    }

    .checkbox-icon-container {
      @apply min-h-[1.5rem] min-w-[1.5rem] relative;
      @apply duration-150 ease-out transition;
      @apply appearance-none bg-neutral-lightest cursor-pointer text-brand;
      @apply border border-secondary-200 border-solid rounded;
      @apply focus:outline-none focus:ring focus:ring-primary-200;
      @apply hover:bg-neutral-lightest hover:border-brand-600;
      @apply active:bg-brand-50 active:border-brand-700;

      &:hover abds-icon {
        @apply text-brand-600;
      }

      &:active abds-icon {
        @apply text-brand-700;
      }

      &.invalid {
        @apply border-danger;
      }
    }

    &([error]) .checkbox-icon-container {
      @apply border-danger;
    }

    /** default order is text/icon on right and input on left */
    &([alignment=end]) {
      abds-supporting-text {
        @apply ml-0;
      }

      .checkbox-icon-container {
        @apply order-2;
      }
    }

    &([disabled]) {
      @apply pointer-events-none;

      abds-icon {
        @apply text-secondary-400;
      }

      abds-label {
        @apply cursor-default;
      }

      .checkbox-icon-container {
        @apply bg-secondary-50 border-secondary-100;

        &.invalid {
          @apply border-danger;
        }
      }
    }
  }
}
